import { BASE_CND } from '../constants/urls';
export const tooltipLogoUrl = logo => {
  return new URL(`design-assets/pcln-bot/logos/${logo}`, BASE_CND);
};